import K_TreeView from "../templates/K_TreeView";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface TreeViewOptions extends ComponentOptions {
    height?: number;
    minHeight?: number;
}

export class TreeView extends TemplateComponent {

    options: TreeViewOptions;

    constructor(options: TreeViewOptions) {
        super(K_TreeView, options);
    }

    create() {
        $("#" + this.id).kendoTreeView({
            loadOnDemand: false
        });
    }

}
